import { Navigate } from "react-router-dom";
import { IReactNode } from "../../interfaces/ICommon";

export const PublicRoute: React.FunctionComponent<IReactNode> = ({ children }) => {
  const user = JSON.parse(sessionStorage.getItem('user') || '{}')
  const userid = user.applicantId;
  if (userid) {
    return <Navigate to={"/home"} />;
  }
  return children;
};
